function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m360.800781 201.628906h-25v115.800782h25c8.285157 0 15-6.714844 15-15v-85.800782c0-8.28125-6.714843-15-15-15zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m0 216.628906v85.800782c0 8.285156 6.714844 15 15 15h25v-115.800782h-25c-8.285156 0-15 6.71875-15 15zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m301.902344 452.003906h-228c-16.570313 0-30 13.429688-30 30v19.996094c0 5.523438 4.476562 10 10 10h268c5.523437 0 10-4.476562 10-10v-19.996094c0-16.570312-13.433594-30-30-30zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m317.902344 107.558594h-18.570313c-12.988281-33.324219-44.257812-57.574219-81.429687-60.335938v-17.222656c0-16.570312-13.433594-30-30-30-16.570313 0-30 13.429688-30 30v17.222656c-37.171875 2.761719-68.441406 27.011719-81.433594 60.335938h-18.566406c-8.285156 0-15 6.71875-15 15 0 8.285156 6.714844 15 15 15h260c8.28125 0 15-6.714844 15-15s-6.71875-15-15-15zm0 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m301.902344 422.003906c1.3125 0 2.609375.054688 3.898437.140625v-254.585937h-235.800781v254.585937c1.289062-.085937 2.589844-.140625 3.902344-.140625zm-114-220.375c31.925781 0 57.898437 25.976563 57.898437 57.898438 0 31.925781-25.972656 57.902344-57.898437 57.902344-31.929688 0-57.902344-25.976563-57.902344-57.898438 0-31.925781 25.972656-57.902344 57.902344-57.902344zm0 0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m187.902344 287.429688c15.382812 0 27.898437-12.515626 27.898437-27.898438 0-15.386719-12.515625-27.898438-27.898437-27.898438-15.386719 0-27.902344 12.515626-27.902344 27.898438s12.515625 27.898438 27.902344 27.898438zm0 0"
});

var SvgHydrant = function SvgHydrant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-68 0 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHydrant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hydrant.720dab56.svg";
export { ForwardRef as ReactComponent };